export const EDIT_DELIVERY_FIELD = "EDIT_DELIVERY_FIELD"
export const RESET_DELIVERY = "RESET_DELIVERY"
